
// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getStorage } from "firebase/storage";
// DEINE ECHTEN KONFIGURATIONSDATEN HIER EINFÜGEN
const firebaseConfig = {
  apiKey: "AIzaSyCUPkun4TT9ROhO-zmyblKz9QK_dsOZ9g4",
  authDomain: "burgerarchitekt-d57038c3.firebaseapp.com",
  projectId: "burgerarchitekt-d57038c3",
  storageBucket: "burgerarchitekt-d57038c3.firebasestorage.app",
  messagingSenderId: "739333921956",
  appId: "1:739333921956:web:a314fcffa4988a6b601a31"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
signInAnonymously(auth)

  .catch((error) => {
    console.error("Fehler beim anonymen Login:", error);
    // Diese Meldung siehst du, wenn etwas mit den Schlüsseln nicht stimmt
    alert("Konnte keine Verbindung zur Datenbank herstellen: " + error.message);
  });
